require(
      "!../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/home/vsts/work/1/s/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/home/vsts/work/1/s/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/home/vsts/work/1/s/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/home/vsts/work/1/s/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 11\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/home/vsts/work/1/s/node_modules/babel-preset-stage-0/lib/index.js\",\"/home/vsts/work/1/s/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./service-focus.js") })
        }
      }, "component---src-templates-services-service-focus-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=component---src-templates-services-service-focus-js!./src/templates/services/service-focus.js
// module id = 792
// module chunks = 231608221292675